import {ProductModelExtended} from '../product/getProductModel';
import {matchesProteinSelection} from './matchesProteinSelection';

const matchesDessertSelection = (
  productDesserts: Array<string> | undefined,
  selectedDessert: string | undefined
): boolean => {
  if (!selectedDessert) {
    return true;
  }

  return productDesserts?.includes(selectedDessert) ?? false;
};

export const findProductForSelection = (
  products: Array<ProductModelExtended>,
  selectedProteins?: Array<string>,
  selectedDessert?: string
): ProductModelExtended | undefined => {
  const matches = products.filter(
    product =>
      matchesProteinSelection(product.proteins, selectedProteins) &&
      matchesDessertSelection(product.dessert, selectedDessert)
  );

  return matches.length === 1 ? matches[0] : undefined;
};
